import { Component, Input } from '@angular/core';

@Component({
	selector: 'quote-from-info',
	template: require('./quote-from-info.html'),
	styles: [require('./quote-from-info.scss')]
})
export class QuoteFromInfoComponent {
	@Input('company') company;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/quote/common/quote-from-info/quote-from-info.ts